<template>
<m-pageframe
    title="Test Edit Controls"
>
<v-container>

    <h1>Action Chips</h1>

    <m-edit-text
        label="Slider Value"
        slider_min="0.1"
        slider_max="2.2"
        slider_step="0.1"
        default_value="1.1"
        v-model="slider_value"
        edit_help_text="This is my <b>help</b> text"
    />

    <m-action-chips
        icon="mdi-account-outline"
        line1="Commerce7 Customer"
        line2="Megan Secor & Jarold Secur"
        line3="Scottsdale, AZ, US"
        clickable
    />
    
    <h2>Edit Text</h2>

    <v-btn
        v-on:click="onClickPickEmoji"
    >
        Pick Emoji
    </v-btn>

    <m-edit-text
        label="Simple Edit Text"
        v-model="value_simple_edit"
        v-on:input="afterSimpleEditValueChanged"
    />

    <m-edit-textarea
        label="Simple Edit Text Area"
        v-model="value_simple_edit_area"
        v-on:input="afterSimpleEditValueChanged"
    />

    <m-edit-text
        label="Read Only"
        v-model="value_read_only"
        read_only
    />

     <m-edit-text
        label="With Menu"
        v-model="value_with_menu"
        :menu_items="menu_items"
        v-on:move-up="moveUp"
        v-on:move-down="moveDown"
    />

    <m-edit-text
        label="Positive, Non Zero Integer"
        v-model="value_positive_non_zero"
        integer_positive_non_zero
    />

    <m-edit-text
        label="Duration"
        v-model="value_duration"
        duration
    />

    {{value_duration}}

    <v-divider
        style="margin-top: 20px; margin-bottom: 20px;"
    />

    <h2>Edit Chips</h2>

    <m-edit-chip
        label="Simple Edit Chips"
        v-model="value_simple_chips"
        v-on:input="afterSimpleEditValueChanged"
        :possible_values="possible_chip_values"
        dialog_title="Edit Simple Chips"
    />
    

    <m-edit-chip
        label="Simple Edit Chips (with menu!)"
        v-model="value_simple_chips"
        v-on:input="afterSimpleEditValueChanged"
        :possible_values="possible_chip_values"
        dialog_title="Edit Simple Chips"
        :menu_items="menu_items"
        v-on:move-up="moveUp"
        v-on:move-down="moveDown"
    />

    <v-divider
        style="margin-top: 20px; margin-bottom: 20px;"
    />

    <h2>Edit Select</h2>

    <m-edit-select
        label="Simple Edit Select"
        v-model="value_select"
        v-on:input="afterSelectValueChanged"
        :possible_values="possible_select_values"
        dialog_title="Edit Select Value"
    />

    <m-edit-select
        label="With Menu!"
        v-model="value_select"
        v-on:input="afterSelectValueChanged"
        :possible_values="possible_select_values"
        dialog_title="Edit Select Value"

        :menu_items="menu_items"
        v-on:move-up="moveUp"
        v-on:move-down="moveDown"
    />

    <m-edit-select-enum
        label="Edit Select Enum (Industry)"
        v-model="value_industry"
        enum_name="industry_code"
        dialog_title="Select an Industry"
    />

    <m-named-pair 
        text="Industry Value"
        :value="value_industry"
    />

    <m-named-pair 
        text="Integration Value (dialog via button only)"
        :value="value_integration"
    />

    <m-edit-select-enum-dialog
            label="Choose Integration"
            enum_name="integration_name"
            :allow_any_enum_value="true"
            ref="choose-integration-dialog"
            v-on:ok="value_integration = $event"
       />

    <v-btn
        v-on:click="onClickChooseIntegration"
    >
        Choose Integration
    </v-btn>
    

    <v-textarea
        label="Text Area!"
        value="I guess some text goes here"
    />

    <h2>Edit Combo Box</h2>
    <v-btn
        style="margin-top: 15px;"
        v-on:click="onClickEditComboxBox"
    >
        Show Edit Combo Box Dialog...
    </v-btn>

    <m-select-currency
        v-model="currency"
    />

    <p>
        <b>Currency:</b> {{currency}}
    </p>

   <m-edit-instant
        label="Scheduled Time"
        v-model="scheduled_time"
    />

    {{scheduled_time}}

    <h2>Contact Card</h2>

    <m-edit-vcard
        v-model="example_vcard_individual"
    />

    <m-edit-vcard
        v-model="example_vcard_organization"
    />

    <m-select-vcard
        endpoint="E164:+16232264931"
        v-model="selected_vcard_id"
    />

    <b>Selected contact card id: </b>{{selected_vcard_id}}

    <h2>Icon Bar</h2>
    <m-icon-bar
        v-on:add="onIconBarAdd"
    />

    <h2>Enhanced Test Field</h2>

    <m-text-field
        label="Text field with emoji"
        v-model="field_with_emoji"
        emoji
    />

    <m-text-field
        label="Text field with emoji"
        v-model="field_with_emoji"
        emoji
        search
        v-on:search="onTextFieldSearch"
    />

    <b>Text Field Value: </b>{{field_with_emoji}}

    <h2>Tags</h2>
    {{tags}}<br/><br/>

    <m-rc-tag-display
        :value="tags"
    />

    <m-edit-tags
        label="My Tag Editor!"
        applies_to="conversation"
        v-model="tags"
    />

    <v-btn
        v-on:click="onClickEditTags"
    >
        Edit Tags...
    </v-btn>

    <h2 style="margin-top: 15px">Tag Search</h2>

    <m-edit-tag-filter
        label="My Tag Filter"
        v-model="tag_filter"
        applies_to="bulk-message"
    />

    {{tag_filter}}

    <h2 style="margin-top: 15px">Emails</h2>

    <m-edit-emails
        v-model="emails"
    />

    {{emails}}

    <h2 style="margin-top: 15px">Legal</h2>

    <m-legal-checkbox-agreement
        type="bulk-message-attestation"
        :organization_id="$rc.$state.getOrganizationId()"
        v-model="bulk_message_attestation"
        ref="bulk_message_attestation"
    />

    bulk_message_attestation = {{bulk_message_attestation}}

    <br/><br/>

    <v-btn
        v-on:click="onClickGetAttestation"
    >
        Get Bulk Message Attestation Specimen
    </v-btn>

    <br/><br/>

    <m-legal-checkbox-agreement
        type="accept-redchirp-subscription-agreement"
        :organization_id="$rc.$state.getOrganizationId()"
        :organization_label="sub_agree_org_label"
        v-model="accept_redchirp_sub_agree"
        ref="accept_redchirp_sub_agree"
    />

    <br/><br/>
    <v-text-field
        label="Organization Label"
        v-model="sub_agree_org_label"
    />

    <br/><br/>

    accept_redchirp_sub_agree = {{accept_redchirp_sub_agree}}

     <v-btn
        v-on:click="onClickGetRedChirpSubAgree"
    >
        Get RedChirp Accept Subscription Agreement Specimen
    </v-btn>

    <br/><br/>

    <b>Pick</b>

    <br/><br/>

    <v-btn
        v-on:click="onClickPick(1)"
        style="margin-right: 15px"
    >
        Pick one - select
    </v-btn>

    <v-btn
        v-on:click="onClickPick(2)"
        style="margin-right: 15px"
    >
        Pick multiple - select
    </v-btn>

    <v-btn
        v-on:click="onClickPick(3)"
        style="margin-right: 15px"
    >
        Pick one - radio
    </v-btn>

    <v-btn
        v-on:click="onClickPick(4)"
        style="margin-right: 15px"
    >
        Pick multiple - checkbox
    </v-btn>

    <br/><br/>

    <b>Autocompletes</b>

    <br/><br/>

    <m-autocomplete
        label="Organization"
        v-model="autocomplete_organization"
        type="organization"
    />

    <br/>
    Organization Id = {{autocomplete_organization}}

    <br/><br/>

    <m-autocomplete
        label="System Admin"
        v-model="autocomplete_system_admin"
        type="system-admins"
    />

    <br/>
    System Admin Id = {{autocomplete_system_admin}}

     <br/><br/>

    <m-autocomplete
        label="Employee"
        v-model="autocomplete_employee"
        type="employees"
    />

    <br/>
    Employee Id = {{autocomplete_employee}}



    <m-edit-monetary-amount
        label="Monetary Amount"
        v-model="monetary_amount"
    />

    <br/>
    Monetary Amount = {{monetary_amount}}

    <br/><br/>

    <v-btn
        style="margin-right: 15px"
    >
        <img src="@/assets/outshinery-logo.png" height="30"/>
    </v-btn>

    <v-btn>
        Media Assets
    </v-btn>
    
    <br/><br/>
    <h2>m-list-buttons</h2>

    <m-list-buttons
        :items="list_button_items"
    />

    <br/><br/>
    <h2>m-todo-bar</h2>

    <m-todo-bar
        label="Waiting on client"
        state="waiting-on-client"
    />
    
    <m-todo-bar
        label="Pending"
        state="pending"
    />

    <m-todo-bar
        label="Done"
        state="done"
    />

    <m-todo-bar
        label="Not Applicable"
        state="not-applicable"
    />

    <m-todo-bar
        :label="todo_label"
        :state="todo_state"
        v-on:click="onClickToDo"
        clickable
    />

    <br/><br/>

    <br/><br/>
    <h2>Prompt Time</h2>

    <v-btn
        v-on:click="onPromptTime(null)"
        style="margin-right: 15px"
    >
        Pick time (no time pre-set)
    </v-btn>

    <v-btn
        v-on:click="onPromptTime(1690810200000)"
    >
        Pick time (July 31, 2023 picked)
    </v-btn>


    <br/><br/>
    <h2>Select Objects</h2>

    <m-edit-select-objects
        label="Bulk Message(s)"
        type="bulk_message"
        v-model="bulk_message_ids"
    />

    Bulk Message Id(s): {{bulk_message_ids}}

    <br/><br/>

    <m-edit-select-objects
        label="Order Type(s)"
        type="crm_order_type"
        v-model="crm_order_types"
    />

    Order Types: {{crm_order_types}}


    <m-edit-wall-time
        label="Edit Time (no timezone)"
        v-model="wall_time"
    />

    <m-edit-wall-time
        label="Edit Time"
        timezone="America/Phoenix"
        v-model="wall_time"
        optional
    />

    <p><b>Wall Time: </b>{{wall_time}}</p>

    <br/><br/>
    <h2>Warnings</h2>

    <p>Warning Code: <code>input_test_warning</code></p>
    <p>Warning Dismissed: <code>{{$rc.$state.isWarningDismissed('input_test_warning')}}</code></p>

    <v-btn
        v-on:click="onClickShowWarning()"
    >
        Show Warning
    </v-btn>

    <v-btn
        v-on:click="$rc.$state.resetDismissedWarnings('input_test_warning'); $forceUpdate();"
    >
        Reset Warning
    </v-btn>

    <br/><br/>
    <h2>Technical Details</h2>

    <v-btn
        v-on:click="onClickTechnicalDetails"
    >
        Show sample technical details
    </v-btn>

    <br/><br/>
    <h2>Long Running Processes</h2>
    
    <v-text-field
        label="Run Time (millis)"
        v-model="unit_test_process_params.run_time"
    />

    <v-checkbox
        label="Throw Exception"
        v-model="unit_test_process_params.throw_exception"
        style="margin-top: -15px"
    />

    <v-btn
        v-on:click="onClickStartUnitTestProcess"
    >
        Start
    </v-btn>

    <br/><br/>
    <h2>Analytics Time Period</h2>

    <m-edit-time-period
        v-model="analytics_time_period"
    />

    {{analytics_time_period}}

    <br/><br/>

    <v-btn
        v-on:click="onClickTestSignInProvision"
    >
        Test Sign In Provision
    </v-btn>

    <br/><br/>
    <h2>Navigation Clicks</h2>
    <v-btn
        v-on:click="onClickNavigiationButton($event,'all-tests')"
        style="margin-right: 15px"
    >
        Navigate: All Tests
    </v-btn>

    <v-btn
        v-on:click="onClickNavigiationButton($event,'https://www.google.com')"
    >
        Navigate: Google
    </v-btn>


    <br/><br/>
    <h2>Validation Fields</h2>

    <m-text-validate-field
        label="Required Email Address"
        v-model="value_validate_email"
        :show_validation_result="value_validate_form_complete"
        required
        email
        persistent-hint
        hint="enter your email address"
    />

    <m-text-validate-field
        label="Optional Email Address"
        :show_validation_result="value_validate_form_complete"
        email
    />

    <m-text-validate-field
        label="Required Phone Number"
        :show_validation_result="value_validate_form_complete"
        required
        phone
    />

    <m-text-validate-field
        label="EIN or CA BN9"
        :show_validation_result="value_validate_form_complete"
        required
        us_or_ca_tax_id
    />

    <m-text-validate-field
        label="URL"
        :show_validation_result="value_validate_form_complete"
        required
        url
    />

    <v-switch
        label="foo"
        v-model="value_validate_form_complete"
    />

    value_validate_email: {{value_validate_email}}
    value_validate_form_complete: {{value_validate_form_complete}}

    
  
</v-container>
</m-pageframe>
</template>

<script>
import mEditWallTime from '../../components/input/m-edit-wall-time.vue';
export default {
  components: { mEditWallTime },
data() {
    return {
        value_simple_edit: 'Hello There',
        value_read_only: 'Read Only Value',
        value_simple_edit_area: 'This can be more than one line',
        
        value_with_menu: 'With a menu!',
        value_industry: 'wine',
        value_integration: null,

        value_positive_non_zero: 10,
        value_duration: 60000*60,
        currency: 'USD',
        scheduled_time: null,

        example_vcard_individual: null,
        example_vcard_organization: null,
        selected_vcard_id: null,
        field_with_emoji: 'Sample text to start',

        bulk_message_attestation: false,
        accept_redchirp_sub_agree: false,

        sub_agree_org_label: 'ZZ Top Inc.',

        monetary_amount: 'USD24.73',

        emails: ['jim.kane@gmail.com','foo@bar.com'],
        crm_order_types: [],

        menu_items: [
            { 'text' : 'Edit', 'event' : 'edit' },
            { 'separator' : true },
            { 'text' : 'Move Up', 'event' : 'move-up' },
            { 'text' : 'Move Down', 'event' : 'move-down' },
        ],

        value_simple_chips: [
            { 'text' : 'Jim', 'id': '7b764d3b-b31a-4428-8d14-42d1c93103f4' },
            { 'text' : 'Jennie', 'id': '7043b9ce-e22a-471f-b3e5-bfd858df89a8' },
        ],

        possible_chip_values : [
            { 'text' : 'Jim', 'id': '7b764d3b-b31a-4428-8d14-42d1c93103f4' },
            { 'text' : 'Jennie', 'id': '7043b9ce-e22a-471f-b3e5-bfd858df89a8' },
            { 'text' : 'Scott', 'id': 'c81efbb6-2e5d-46b6-90e8-44577bafe088' },
            { 'text' : 'Angela', 'id': 'd26f8cec-f72c-4f77-ab3e-b6aa1a7c4532' },
            { 'text' : 'Big D', 'id': '519d70bd-01ac-4053-a8bf-a694e6c533f7' },
        ],

        tags: [
            'b1ced1ba-7e02-4dcf-81b2-0847a00080e3',
        ],

        tag_filter: { 'type': 'includes-any', 'values' : ['b1ced1ba-7e02-4dcf-81b2-0847a00080e3','288e962c-60d4-466f-9085-41e2db6fc45f'] },

      

        value_select: { 'text' : 'Potsdam, NY', 'zip': '13676' },

        possible_select_values : [
            { 'text' : 'Potsdam, NY', 'zip': '13676' },
            { 'text' : 'Scottsdale, AZ', 'zip': '85254' },
            { 'text' : 'Flagstaff, AZ', 'zip': '86001' },
            { 'text' : 'Canton, NY', 'zip': '13617' },
        ],

        autocomplete_organization: null,
        autocomplete_system_admin: null,
        autocomplete_employee: null,

        list_button_items: [
            { 'title': 'First Button', 'sub_title': 'This is the first button', 'icon': 'mdi-account', 'action': this.listButtonsFirstAction },
            { 'title': 'Second Action', 'sub_title': 'This is the second button', 'icon': 'mdi-play', 'action': this.listButtonsSecondAction },
        ],

        todo_state: 'needs-confirmation',
        todo_label: 'Confirm something',

        bulk_message_ids: [ '7a3538d2-d47e-431b-8066-0b39cd578b78' ],

        wall_time: '17:42',
        technical_details: null,

        unit_test_process_params: { 'run_time': 10000, 'throw_exception': false},

        analytics_time_period: null,

        value_validate_email: null,
        value_validate_form_complete: false,

        slider_value: 1.1,
    }
},

mounted () {
    this.$rc.showSpinner();
    
    this.$rc.rest(
        'LIST: /api/v1/vcard',
    
        {
            'organization_id': '8a732595-6621-4d6d-af37-0819110ae721' // Red Rock Realty...
        },
    
        (data) => {
            this.$rc.hideSpinner();

            for ( let i = 0; i < data.results.length; i++ )
            {
                let result = data.results[i];

                if ( result.kind == 'individual' ) 
                {
                    this.example_vcard_individual = result;
                }

                if ( result.kind == 'organization' ) 
                {
                    this.example_vcard_organization = result;
                }

            }
        },
    
        () => {
            this.$rc.hideSpinner();
            this.$rc.alert('Error','Unable to complete API call');
        },
    );

    this.$rc.rest({
        'spinner': false,
        'endpoint': 'GET: /api/v1/public/sample-technical-details',
    
        'params' : {
            },
    
        'on_success': (data) => {
                this.technical_details = data;
            },
    
        'on_error': 'Unable to complete API call',
    });
},

methods: {
    listButtonsFirstAction()
    {
        alert("hopa!");
    },

    listButtonsSecondAction()
    {
        alert("hola!");
    },

    afterSimpleEditValueChanged() 
    {
        alert(this.value_simple_edit);
    },

    afterSelectValueChanged()
    {
        alert(JSON.stringify(this.value_select));
    },

    moveUp()
    {
        alert('Move up');
    },

    moveDown()
    {
        alert('Move down');
    },

    onClickChooseIntegration()
    {
        this.$refs['choose-integration-dialog'].showDialog(this.value_integration);
    },

    onClickEditComboxBox()
    {
        this.$rc.combo_box_prompt({
            'title': 'Put your title here!',
            'label': 'Put your label here!',
            'items': ['foo','bar','baz'],
            'after_prompt': (value) => {
                alert(value);
            }
        });
    },

    onClickPickEmoji()
    {
        this.$rc.simplePickEmoji((value) => { alert('Emoji picked: '+value); })
    },

    onIconBarAdd()
    {
        alert("add button has been clicked");
    },

    onTextFieldSearch()
    {
        alert('Search (initiated from text field)');
    },

    onClickEditTags()
    {
        this.$rc.change_tags_dialog({
            'organization_id': '8a732595-6621-4d6d-af37-0819110ae721', // Red Rock Realty...
            'applies_to': 'conversation',
            'selected_tag_ids': this.tags,
            'show_archived': false,
            'on_save': (ids) => {
                this.tags = ids;
            }
        });
    },

    onClickGetAttestation()
    {
        alert(this.$refs['bulk_message_attestation'].getSpecimen());
    },

    onClickGetRedChirpSubAgree()
    {
        alert(this.$refs['accept_redchirp_sub_agree'].getSpecimen());
    },

    onClickPick(code)
    {
        if ( code == 1 )
        {
            // Pick one -- select
            this.$rc.pick({
                'title': 'Select your favorite fruit',
                'content_before': 'Select your favorite fruit',
                'choices': [
                    {'text': 'Apple', 'value': 'apple'},
                    {'text': 'Bannana', 'value': 'bannana'},
                    {'text': 'Peach', 'value': 'peach'},
                    {'text': 'Pear', 'value': 'pear'},
                ],

                'multiple': false,
                'type': 'select',
                'select_label': 'Fruit',
                'initial_value': null,

                'content_after': 'No judgement!',
                
                'on_ok': (value) => {
                    alert(value);
                },

                'on_cancel': () => {
                    alert('cancelled');
                }
            });
        }

        if ( code == 2 )
        {
            // Pick one -- select multiple
            this.$rc.pick({
                'title': 'Select some fruit',
                'content_before': 'Select some fruit that you enjoy',
                'choices': [
                    {'text': 'Apple', 'value': 'apple'},
                    {'text': 'Bannana', 'value': 'bannana'},
                    {'text': 'Peach', 'value': 'peach'},
                    {'text': 'Pear', 'value': 'pear'},
                ],

                'multiple': true,
                'type': 'select',
                'select_label': 'Fruit',
                'initial_value': null,

                'content_after': 'No judgement!',
                
                'on_ok': (value) => {
                    alert(value);
                },

                'on_cancel': () => {
                    alert('cancelled');
                }
            });
        }

        if ( code == 3 )
        {
            // Pick one -- radio
            this.$rc.pick({
                'title': 'Select your favorite fruit',
                'content_before': 'Select your favorite fruit',
                'choices': [
                    {'text': 'Apple', 'value': 'apple'},
                    {'text': 'Bannana', 'value': 'bannana'},
                    {'text': 'Peach', 'value': 'peach'},
                    {'text': 'Pear', 'value': 'pear'},
                ],

                'multiple': false,
                'type': 'radio',
                'initial_value': null,

                'content_after': 'No judgement!',
                
                'on_ok': (value) => {
                    alert(value);
                },

                'on_cancel': () => {
                    alert('cancelled');
                }
            });
        }

        if ( code == 4 )
        {
            // Pick multiple -- checkbox
            this.$rc.pick({
                'title': 'Select some fruit',
                'content_before': 'Select some fruit that you enjoy',
                'choices': [
                    {'text': 'Apple', 'value': 'apple'},
                    {'text': 'Bannana', 'value': 'bannana'},
                    {'text': 'Peach', 'value': 'peach'},
                    {'text': 'Pear', 'value': 'pear'},
                ],

                'multiple': true,
                'type': 'cb',
                'initial_value': null,

                'content_after': 'No judgement!',
                
                'on_ok': (value) => {
                    alert(value);
                },

                'on_cancel': () => {
                    alert('cancelled');
                }
            });
        }
    },

    onPromptTime(original_value)
    {
        this.$rc.promptTime({
            'value': original_value,
            'on_set': (time) => {
                this.$rc.alert('Time picked', time);
            },
        });
    },

    onClickToDo()
    {
        this.$rc.confirm({
            'title': 'Confirm Something',
            'body': 'You need to confirm something',
            'btn_text_ok': 'Yes',
            'btn_text_cancel': 'No',
            'on_ok': () => {
                this.todo_state = 'done';
            },
        });
    },

    onClickShowWarning()
    {
        this.$rc.warn({
            'warning_code': 'input_test_warning',
            'title': 'Test warning',
            'text': 'This is a test warning',
            'label_ok': 'Ok',
            'label_cancel': 'Cancel',
            'label_dismiss': 'Do not show again',
        
            'on_ok': () => {
                alert('After warning: OK');
                this.$forceUpdate();
            },
        
            'on_cancel': () => {
                alert('After warning: Cancel');
                this.$forceUpdate();
            },
        });
    },

    onClickTechnicalDetails()
    {
        this.$rc.technicalDetails({
            'title': 'Technical Details Test',
            'technical_details': this.technical_details,
        });
    },

    onClickStartUnitTestProcess()
    {
        this.$rc.startProcess({
            'type': 'unit-test',
            'params': this.unit_test_process_params,
        
            'title': 'RedChirp is doing some work!',
            'finished_button_text': 'Proceed',
            'failed_button_text': 'Cancel',
        
            status: (pte) => {
                return 'Doing some work: '+pte.progress_counter;
            },
        
            on_finished: (pte) => {
                alert('success!');
            },
        
            on_failed: (pte) => {
                alert('failed');
            },
        
        });
    },

    onClickTestSignInProvision()
    {
        this.$rc.newSignInAs({
            'organization_id': '0f0b45f1-9dfb-468d-bcd4-fcb49ef01154',
            'employee_id': 'any-org-admin', 
            'after_route': {
                'name': 'provision',
                'params' : {
                    'organization_id': '0f0b45f1-9dfb-468d-bcd4-fcb49ef01154',
                },
            },
        });
    },

    onClickNavigiationButton(event, name)
    {
        let route = {
            'name': name,
        };

        this.$rc.navigationClick(this.$router, route, event);
    },
},

    
}
</script>

<style lang="scss" scoped>

</style>